<template>
  <div id="app">
    <component :is="layout">
      <transition name="fade" mode="out-in" @after-enter="scrollTo($route.hash)">
        <router-view class="view"></router-view>
      </transition>
    </component>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

import { color } from '@/variables'
import { ClimbingBoxLoader } from '@saeris/vue-spinners'

import { scrollTo } from '@/utils/utils.js'

export default {

  components: {
    'loader': ClimbingBoxLoader
  },

  data () {
    return {
      color
    }
  },

  computed: {
    ...mapState(['$loading']),

    layout () {
      return (this.$route.meta.layout || 'default') + '-layout'
    }
  },

  mounted () {
  },

  methods: {
    ...mapMutations(['increase$loading', 'decrease$loading']),
    scrollTo
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables.scss';

.fade-enter-active, .fade-leave-active {
  transition: opacity .6s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.loader {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0; left: 0; bottom: 0; right: 0;
  z-index: 1000000;
  background-color: rgba($dark-shades, .85);

  display: flex;
  justify-content: center;
  align-items: center;
  transition: all .8s ease;

  &__spinner {
    z-index: 1000001;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue